import { TableCell, TableRow } from '@material-ui/core';
import { formatMoney, Pricing } from '@nemuru-eng/js-api-client';

import { CustomHeader } from '@/components/shared/components/CustomTable/CustomHeader';
import { usePricingsTable } from '@/components/shared/components/PricingsTable/hooks/usePricingsTable';
import { useDefaultTable } from '@/components/shared/hooks/useDefaultTable';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';

export const PricingMinimalTable = ({ selectedPricing }: { selectedPricing: Pricing }) => {
  const { classes, columns } = usePricingsTable({
    minimalTable: true,
    paymentMethodTypes: selectedPricing.paymentMethodTypes,
  });
  const tableElementId = 'pricing-table-minimal-container';

  const { classes: tableHeaderClasses, stickyCellStyle } = useDefaultTable({
    tableElementId,
  });

  return (
    <>
      <CustomHeader tableProps={{ classes: tableHeaderClasses, stickyCellStyle }} columns={columns} />
      <TableRow key={selectedPricing.id} className={classes.root}>
        <TableCell align={'left'} height={54}>
          <Font variant={'body2'} color={'textPrimary'}>
            {selectedPricing.name}
          </Font>
        </TableCell>
        <TableCell align={'left'} height={54}>
          <Font variant={'body2'} color={'textPrimary'}>
            <Text tId={selectedPricing.program} />
          </Font>
        </TableCell>
        <TableCell align={'left'} height={54}>
          <Font variant={'body2'} color={'textPrimary'}>
            {`${formatMoney({
              value: selectedPricing.rangePrincipalMin,
              currency: selectedPricing.currency,
            })} - ${formatMoney({
              value: selectedPricing.rangePrincipalMax,
              currency: selectedPricing.currency,
            })}`}
          </Font>
        </TableCell>
        <TableCell align={'left'} height={54}>
          <Font variant={'body2'} color={'textPrimary'}>
            {!selectedPricing.rangePeriodMin
              ? '-'
              : `${selectedPricing.rangePeriodMin?.toFixed(0)} - ${selectedPricing.rangePeriodMax?.toFixed(0)}`}
          </Font>
        </TableCell>
      </TableRow>
    </>
  );
};
